export const validateFromServer = (getter, promise) => function (value) {
  return promise ? promise.then(getter) : true
}